import { RefreshCwIcon } from 'lucide-react'
import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { log } from '@/lib/log'

/**
 * Shown when a page fails to render. Logs the error with the `[hugo]` prefix so browser checks
 * find it, and offers a reload instead of leaving a blank screen.
 */
export function ErrorView({ error, reset }: { error: unknown; reset?: () => void }) {
  const message = error instanceof Error ? error.message : String(error)
  useEffect(() => {
    log.error(`render error: ${message}`)
  }, [message])
  return (
    <main
      data-view="error"
      data-state="error"
      role="alert"
      className="flex min-h-[60svh] flex-1 flex-col items-center justify-center gap-4 px-6 text-center"
    >
      <h1 className="font-heading text-xl font-semibold">Something went wrong</h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        This view could not be shown. Your data is safe. Try again, or reload hugo.
      </p>
      <div className="flex gap-2">
        {reset ? (
          <Button variant="outline" onClick={reset}>
            Try again
          </Button>
        ) : null}
        <Button onClick={() => window.location.reload()}>
          <RefreshCwIcon aria-hidden="true" />
          Reload
        </Button>
      </div>
    </main>
  )
}
